let footerConfig = require('../config/footerLinks.json');

let Footer = {
  render() {
    // console.log('footerConfig:', JSON.stringify(footerConfig, null, '\t'));
    let footerLinksWrapper = $('<div>', {
      id: 'footerLinksWrapper',
      class: 'row',
      html: '&nbsp;',
    }).appendTo($('footer'));
    $.each(footerConfig.links, function(key, val) {
      console.log('key:' + key + ' val:' + JSON.stringify(val, null, '\t'));
      $('<a>', {
        class: 'footerLink col ' + key,
        title: val.titel,
        href: val.href,
        target: '_blank',
      }).appendTo(footerLinksWrapper);
    });
  },
};
export default Footer;
